/* Forge scroll-reveal: fade static forge sections up as they enter view.
   Skips entirely under reduced-motion or no IntersectionObserver, leaving
   content visible. Pairs with .forge-reveal--armed rules in forge.css. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var els = document.querySelectorAll('[data-forge-reveal]');
  if (!els.length) return;
  document.documentElement.classList.add('forge-reveal--armed');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { io.observe(el); });
})();
